import { FC } from 'react';
import ExperianAdvert from './ExperianAdvert/ExperianAdvert';
import { BarrattAdvert } from '@zoopla/adverts/partnership-adslots';
import { ReactComponent as ReactComponentGQL } from '../../graphql.generated';

type ReactComponentProps = {
    slug: string;
    componentName: string;
    contentType?: string | null;
    title: string;
    body?: ReactComponentGQL['body'];
};

const ReactComponent: FC<ReactComponentProps> = ({
    slug,
    componentName,
    title,
    body,
}) => {
    if (componentName === 'Advert: Experian') {
        return <ExperianAdvert slug={slug} />;
    } else if (componentName === 'Advert: Barratt Homes') {
        return <BarrattAdvert slug={slug} />;
    }

    return null;
};

export default ReactComponent;
